import { Pipe, PipeTransform } from '@angular/core';
import { StudentGroupSize } from '../interfaces/user';

@Pipe({
  name: 'studentGroupSize'
})
export class StudentGroupSizePipe implements PipeTransform {

  transform(value: StudentGroupSize, args?: any): any {
    switch(value){
      case StudentGroupSize.ExtraSmall: {
        return '1-3';
      }
      case StudentGroupSize.Small: {
        return '4-8'
      }
      case StudentGroupSize.Medium: {
        return '9-15';
      }
      case StudentGroupSize.Large: {
        return '16-20';
      }
      case StudentGroupSize.ExtraLarge: {
        return '21-25';
      }
      default: {
        return '';
      }
    }
  }

}
